import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PosDetailWithOrders } from '../../../../../../../core/models/pos.model';

@Component({
  selector: 'app-order-list-wrapper',
  templateUrl: './order-list-wrapper.component.html',
  styleUrls: ['./order-list-wrapper.component.scss']
})
export class OrderListWrapperComponent implements OnInit {
  pos: PosDetailWithOrders;
  orderTotal: number;

  constructor(
    private matDialogRef: MatDialogRef<OrderListWrapperComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.pos = this.data.pos;
    }
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  updateOrderTotal($event: number) {
    this.orderTotal = $event;
  }
}
